import * as React from 'react'

function IconAssistantWinking(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={134}
      height={133}
      viewBox="0 0 134 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M133.7 66.5C133.7 29.773 103.927 0 67.2 0 30.473 0 .7 29.773.7 66.5c0 36.727 29.773 66.5 66.5 66.5 36.727 0 66.5-29.773 66.5-66.5z"
        fill="#F4BA27"
      />
      <path
        d="M106.046 82.936A7.894 7.894 0 0198.3 90.65a5.737 5.737 0 01-.65 0 5.032 5.032 0 00-4.813 2.56c-5.69 10.332-16.533 15.445-27.182 15.25-10.754-.512-21.329-6.414-26.296-17.306a4.356 4.356 0 00-4.161-2.544h-.415a7.876 7.876 0 01-7.803-7.6 7.83 7.83 0 018.039-8.056 1.52 1.52 0 001.626-1.366c2.186-22.345 16.89-33.27 31.23-32.912 14.314.569 28.27 12.404 29.027 34.815a1.568 1.568 0 001.528 1.511 7.826 7.826 0 017.616 7.934z"
        fill="#fff"
      />
      <path
        d="M95.552 81.733a.577.577 0 01-.422-.211.562.562 0 01.09-.813c.13-.106 3.194-2.439 8.184-1.146a.557.557 0 01.338.26.54.54 0 01.053.422.561.561 0 01-.683.399c-4.422-1.179-7.088.813-7.202.934a.544.544 0 01-.358.155z"
        fill="#000"
      />
      <path
        d="M102.291 83.416a.544.544 0 01-.447-.26 5.626 5.626 0 00-3.804-2.561.553.553 0 01-.433-.817.553.553 0 01.547-.288 6.72 6.72 0 014.625 3.064.554.554 0 01.094.444.57.57 0 01-.265.369.552.552 0 01-.317.049zM84.067 74.694a.57.57 0 00-.44.276 5.56 5.56 0 01-3.673 2.74.561.561 0 00-.464.642.561.561 0 00.634.463 6.715 6.715 0 004.471-3.252.55.55 0 00-.203-.756.594.594 0 00-.325-.113z"
        fill="#000"
      />
      <path
        d="M85.083 76.799a.56.56 0 01.398.26.553.553 0 01-.17.764c-.139.09-3.439 2.122-8.26.276a.553.553 0 01-.316-.715.545.545 0 01.715-.325c4.276 1.626 7.145-.106 7.259-.179a.577.577 0 01.374-.081zM38.327 79.888a.586.586 0 01-.35-.147c-.113-.097-2.633-2.292-7.128-1.406a.547.547 0 01-.65-.439.543.543 0 01.43-.65c5.073-1.008 7.975 1.56 8.13 1.626a.545.545 0 010 .813.555.555 0 01-.432.203z"
        fill="#000"
      />
      <path
        d="M31.491 81.123a.544.544 0 01-.309-.105.56.56 0 01-.122-.813 6.781 6.781 0 014.82-2.764.561.561 0 01.43.937.553.553 0 01-.389.177 5.627 5.627 0 00-3.958 2.308.553.553 0 01-.472.26zM67.314 86.529a.56.56 0 01-.47-.822.555.555 0 01.331-.267c4.39-1.334 4.699-2.065 4.707-2.203.04-.301-1.04-.935-1.683-1.317a7.43 7.43 0 01-2.65-2.138c-1.585-2.666-.512-12.477-.382-13.59a.56.56 0 011.092-.089c.02.071.024.145.014.218-.334 2.91-.943 10.909.235 12.884a6.828 6.828 0 002.26 1.756c1.203.715 2.35 1.39 2.227 2.438-.121 1.049-1.089 1.789-5.503 3.13a.63.63 0 01-.178 0zM68.882 91.317a6.503 6.503 0 01-6.502-5.422.56.56 0 01.487-.618.56.56 0 01.618.48c0 .187.634 4.413 5.625 4.446a.593.593 0 01.553.569.552.552 0 01-.561.553l-.22-.008zM54.608 77.876c.05-1.535-.619-2.802-1.494-2.83-.875-.029-1.624 1.193-1.674 2.727-.05 1.535.62 2.802 1.495 2.83.874.028 1.624-1.193 1.673-2.727z"
        fill="#000"
      />
      <path
        d="M35.019 72.954S19.2 70.654 22.233 56.9c3.032-13.753 7.998-12.079 11.314-20.492 3.317-8.413 17.07-15.29 31.97-9.324 14.9 5.967 25.687-5.568 35.652-1.739 9.966 3.829 1.756 11.778 3.333 15.33 1.577 3.553 8.047 5.74 5.958 13.892-2.089 8.153-6.576 22.126-12.778 20.216-5.227-1.626-4.414-22.126-13.005-25.296-7.845-2.91-19.582 8.519-33.962 3.251a3.177 3.177 0 00-4.251 2.666c-.626 6.528-3.048 17.802-11.445 17.55z"
        fill="#E84E25"
      />
      <path
        d="M47.342 71.02a.561.561 0 01-.463-.845c0-.066 4.178-6.853 11.583-4.764a.569.569 0 01.382.69.56.56 0 01-.691.383c-6.584-1.862-10.275 4.194-10.315 4.26a.577.577 0 01-.496.275zM87.903 67.72a.57.57 0 00-.56.105c-.22.195-5.463 4.658-11.129.813a.56.56 0 00-.772.146.561.561 0 00.155.813c6.38 4.284 12.42-.886 12.477-.943a.544.544 0 00.057-.813.618.618 0 00-.228-.122z"
        fill="#000"
      />
      <path
        d="M52.81 89.466c4.21-.735 7.384-2.707 7.087-4.405-.296-1.698-3.95-2.48-8.16-1.745-4.21.735-7.383 2.708-7.086 4.406.296 1.698 3.95 2.479 8.16 1.744zM89.695 89.424c.472-1.658-2.477-3.951-6.587-5.122-4.11-1.17-7.826-.776-8.298.882-.472 1.658 2.477 3.951 6.587 5.122 4.11 1.17 7.825.776 8.298-.882z"
        fill="#FFDEDE"
      />
    </svg>
  )
}

export default IconAssistantWinking
